import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import EntidadesView from './EntidadesView';
import * as ROUTES from '../../../router/Routes';

const EntidadesModule = () => {
  return (
    <ContainerTemplate active={ROUTES.entidades} routes={[ROUTES.root]}>
      <EntidadesView />
    </ContainerTemplate>
  );
};

export default EntidadesModule;
